/**
 * Cura — Trust Numbers count-up
 * Counts each number from 0 to its target when the section scrolls into view.
 * Triggers once. Respects prefers-reduced-motion (shows final value instantly).
 */
(function () {
  'use strict';

  function animateCount(el, duration) {
    const target = parseFloat(el.dataset.countTarget) || 0;
    const prefix = el.dataset.countPrefix || '';
    const suffix = el.dataset.countSuffix || '';
    const isInt = Number.isInteger(target);

    const start = performance.now();
    function frame(now) {
      const progress = Math.min((now - start) / (duration * 1000), 1);
      // easeOutCubic for a natural deceleration
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = target * eased;
      const display = isInt ? Math.round(value) : value.toFixed(1);
      el.textContent = prefix + (target>=1900&&target<=2100?String(display):display.toLocaleString('en-IN')) + suffix;
      if (progress < 1) requestAnimationFrame(frame);
      else el.textContent = prefix + (target>=1900&&target<=2100?String(Math.round(target)):(isInt ? Math.round(target) : target).toLocaleString('en-IN')) + suffix;
    }
    requestAnimationFrame(frame);
  }

  function initSection(section) {
    const counts = Array.from(section.querySelectorAll('[data-count-target]'));
    if (!counts.length) return;

    const duration = parseFloat(getComputedStyle(section).getPropertyValue('--cura-tn-duration')) || 2;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      counts.forEach((el) => {
        const t = parseFloat(el.dataset.countTarget) || 0;
        el.textContent = (el.dataset.countPrefix || '') + t.toLocaleString('en-IN') + (el.dataset.countSuffix || '');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        counts.forEach((el) => animateCount(el, duration));
        observer.disconnect(); // run once
      });
    }, { threshold: 0.3 });

    observer.observe(section);
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-cura-tn]').forEach(function (el) {
      if (!el.dataset.tnInit) {
        initSection(el);
        el.dataset.tnInit = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();